export enum SfNodeType {
	Decisions = 'decisions',
	RecordCreates = 'recordCreates',
	RecordUpdates = 'recordUpdates',
	RecordLookups = 'recordLookups'
}
